<template>
    <div class="form-container">
        <div class="page-text page-text--xs grey--text text-right pb-16 pb-md-20"><span class="secondary--text">*</span> 필수입력 항목입니다.</div>
        <v-form v-model="isValid">
            <vertical-form-table v-model="form" v-bind="{ items }"></vertical-form-table>

            <div class="pb-0 mt-16 mt-md-24 mt-lg-32">
                <terms-of-agreements-short v-model="form._terms" @isValid="(isValid) => (isTermsValid = isValid)" />
            </div>

            <div class="mt-30 mt-md-44 mt-lg-60">
                <v-row justify="center" class="row row--small">
                    <v-col cols="6" sm="auto">
                        <v-btn large color="grey lighten-3" outlined class="w-100 min-w-sm-160px">
                            <span class="grey--text">취소</span>
                        </v-btn>
                    </v-col>
                    <v-col cols="6" sm="auto">
                        <v-btn large color="secondary" class="w-100 min-w-sm-160px" v-bind="{ disabled }" @click="$emit('save')">
                            <span class="white--text">작성완료</span>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-form>
    </div>
</template>

<script>
import { initUser, rules } from "@/assets/variables";

import PageSection from "@/pages/client/templates/page-section.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import TermsOfAgreementsShort from "@/components/client/terms/terms-of-agreements-short.vue";
// import ImagesInput from "@/components/console/dumb/images-input.vue";
// import MyinfoModifyRow from "@/components/client/mypage/myinfo-modify-row.vue";

import api from "@/api";

const items = [
    {
        key: "meta.name",
        term: "이름",
        type: "text",
        required: true,
        placeholder: "이름을 입력하세요.",
        // rules: rules.name,
    },
    // {
    //     key: "meta.company",
    //     term: "Company",
    //     type: "text",
    //     required: true,
    //     placeholder: "Type a company name.",
    // },
    {
        key: "meta.phone",
        term: "연락처",
        type: "phone",
        required: true,
        placeholder: "'-'를 제외하고 입력하세요.",
        // rules: rules.phone,
    },
    {
        key: "meta.email",
        term: "이메일",
        type: "email",
        required: true,
        placeholder: "이메일을 입력하세요.",
        // rules: rules.email,
    },
    {
        key: "meta.message",
        term: "문의내용",
        type: "textarea",
        required: true,
        placeholder: "내용을 입력하세요.",
    },
    // {
    //     key: "meta.file",
    //     term: "Attachment",
    //     type: "file",
    //     required: false,
    //     placeholder: "Search",
    // },
].map((item) => ({ ...item, outlined: true }));

export default {
    components: {
        PageSection,
        VerticalFormTable,
        TermsOfAgreementsShort,
        // ImagesInput,
        // MyinfoModifyRow,
    },
    props: {
        value: { type: Object, default: null },
    },
    data() {
        return {
            work: null,
            form: this.$props.value,

            // form: initUser(),
            items,
            isValid: false,
            isTermsValid: false,
        };
    },
    computed: {
        _work() {
            return this.$route.query._work;
        },

        disabled() {
            return !this.isTermsValid;
        },
    },
    // mounted() {
    //     this.init();
    // },
    watch: {
        value() {
            this.board = this.value;
        },
    },
    methods: {
        async init() {
            const { _work: _id } = this;
            const { work } = await api.v1.auction.works.get({ _id });
            this.work = work;
        },

        validates() {
            try {
                switch (this.isTermsValid) {
                    case undefined:
                        throw new Error("이용약관을 확인해주세요");
                    case false:
                        throw new Error("필수 이용약관에 모두 동의해주세요");
                    default:
                        break;
                }
                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },
    },
};
</script>
